<template>
  <div style="padding-top: 80px; ">
    <TopNav activeIndex="4"></TopNav>
    <div class="school-header">
      <div class="school-header-container">
        <div class="school-herder-title">开放 合作 共赢</div>
        <div class="school-header-text">
          <p>寻求学校、机构一起合作</p>
          <p>为国家培养人工智能创造型人才</p>
        </div>
      </div>
    </div>
    <div class="school">
      <div class="school-container">
        <div class="school-text-container">
          <div class="school-title">线下校区 /<span style="color: #999; font-size: 22px"> Offline Campus</span> </div>
          <div class="school-line"></div>
          <div class="school-s-title">一线互联网高级研发工程师亲自授课</div>
          <div class="school-list">
            <div class="school-item" v-for="(v, i) in campuslList" :key="i">
              <img :src="v.url">
              <div class="school-name">{{ v.name }}</div>
              <div class="school-phone">
                <img src="../../../static/images/icon5.png">
                <span>{{ v.phone }}</span>
              </div>
              <div class="school-pos">
                <img src="../../../static/images/icon4.png">
                <span>{{ v.pos }}</span>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
    <div class="cooperation">
      <div class="school-container">
        <div class="school-text-container">
          <div class="school-title">合作机构 /<span style="color: #999; font-size: 22px">Cooperative Institutions</span>
          </div>
          <div class="school-line"></div>
          <div class="school-s-title">在全国各地和多家教育机构达成深度合作</div>
          <div class="swiper-container">
            <div class="student-container swiper-wrapper">
              <div class="cooperation-item swiper-slide" v-for="(v, i) in hzjg" :key="i">
                <img :src="v.url">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="cooperation">
      <div class="school-container">
        <div>
          <div class="school-title">合作学校 /<span style="color: #999; font-size: 22px">Cooperative School</span> </div>
          <div class="school-line"></div>
          <div class="school-s-title">哆哆创客STEAM创新课程走进幼儿园</div>
          <div class="school-img-container ">
            <img style=" margin-top:40px ; width: 1189px; margin-bottom: 50px;"
              src="../../../static/images/school/1.png" />
          </div>
          <div class="school-s-title">哆哆创客图形化趣味编程进驻中小学</div>
          <div class="school-list">
            <div class="school-item2" v-for="(v, i) in schoolList" :key="i">
              <img :src="v">
            </div>
          </div>
        </div>

      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import TopNav from '@/components/top/TopNav'
import Footer from '@/components/bottom/Footer'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'

export default {
  components: {
    TopNav,
    Footer
  },
  data() {
    return {
      schoolList: [
        '../../../static/images/school/20.png',
        '../../../static/images/school/21.png',
        '../../../static/images/school/22.png',
        '../../../static/images/school/23.png',
        '../../../static/images/school/24.png',
        '../../../static/images/school/25.png',
        '../../../static/images/school/26.png',
        '../../../static/images/school/27.png',
        '../../../static/images/school/29.png',
      ],
      campuslList: [{
        url: '../../../static/images/institution/1.jpg',
        name: '研发中心',
        phone: '177 2400 2195',
        pos: '佛山市南海区碧桂园广佛上城11栋903-904'
      },
      {
        url: '../../../static/images/institution/3.jpg',
        name: '汇太广场直营校区',
        phone: '181 4873 9211',
        pos: '广州增城区新塘镇汇太广场米萝教育城3A楼'
      },
      {
        url: '../../../static/images/institution/4.jpg',
        name: '新世界花园直营校区',
        phone: '177 2426 2770',
        pos: '广州增城区新塘镇新世界花园金昂教育二楼'
      },
      {
        url: '../../../static/images/institution/2.jpg',
        name: '广东省社区青少年宫（星凯乐宫）',
        phone: '181 4873 9211',
        pos: '广州增城区新塘镇峰景路25号28-32铺'
      },
      {
        url: '../../../static/images/institution/6.jpg',
        name: '广东省社区青少年宫（翡翠绿洲）',
        phone: '181 4873 9211',
        pos: '广州增城区新塘镇陈家林路237号'
      },
      {
        url: '../../../static/images/institution/5.jpg',
        name: '中堂校区',
        phone: '181 4873 9211',
        pos: '东莞市振兴路中天·城市广场金昂教育'
      }
      ],
      hzjg: [{
        url: '../../../static/images/cooperation/1.jpg'
      },
      {
        url: '../../../static/images/cooperation/2.jpg'
      },
      {
        url: '../../../static/images/cooperation/3.jpg'
      },
      {
        url: '../../../static/images/cooperation/4.jpg'
      }
      ]
    }
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    initSwiper() {
      this._swiperMain = new Swiper('.swiper-container', {
        slidesPerView: 4,
        spaceBetween: 0,
        centeredSlides: true,
        slideToClickedSlide: true,
        initialSlide: 0,
        loop: true,
        speed: 1000,
        autoplay: true
      })
    }
  }
}

</script>
<style>
@import url('./school.css');
</style>



// WEBPACK FOOTER //
// src/pages/school/school.vue